import { useEffect, useMemo, useState } from 'react';
import { useHandler } from '@kinesis/bungle';

function useEditState([value, onChange], editMode) {
  const [state, setState] = useState(value);
  const [dirty, setDirty] = useState(false);
  const handleChange = useHandler(onChange);

  useEffect(() => {
    if (!editMode) {
      if (dirty && value !== state) {
        handleChange(state);
      }
      setDirty(false);
    }
  }, [dirty, editMode, handleChange, state, value]);

  useEffect(() => {
    if (!dirty) {
      setState(value);
    }
  }, [dirty, value]);

  return useMemo(
    () => [
      state,
      (newState) => {
        setState(newState);
        setDirty(true);
      },
    ],
    [state],
  );
}

export { useEditState };
